interface FestSectionProps {
  onWhatsAppClick: () => void;
}

export default function FestSection({ onWhatsAppClick }: FestSectionProps) {
  return (
    <section id="festa" className="py-16 bg-gradient-to-br from-pink-500 via-purple-600 to-indigo-700 relative overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center opacity-30"></div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">🎉 Alegria e Diversão na Balada! 🎉</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-yellow-400 to-pink-500 mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-white max-w-3xl mx-auto leading-relaxed">
            DJ Jean traz toda a energia e diversão que sua festa precisa! Com beats incríveis, efeitos especiais e uma atmosfera única.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          <div className="bg-white/15 backdrop-blur-lg p-6 rounded-2xl border border-white/20 text-center">
            <div className="w-16 h-16 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-volume-up-fill text-white text-2xl"></i>
            </div>
            <h3 className="text-white font-bold text-xl mb-3">Som Potente</h3>
            <p className="text-white/90 text-sm">Sistema de som profissional que faz a pista vibrar! Graves potentes e qualidade única.</p>
          </div>
          
          <div className="bg-white/15 backdrop-blur-lg p-6 rounded-2xl border border-white/20 text-center">
            <div className="w-16 h-16 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-flashlight-fill text-white text-2xl"></i>
            </div>
            <h3 className="text-white font-bold text-xl mb-3">Show de Luzes</h3>
            <p className="text-white/90 text-sm">Efeitos de luz sincronizados! Lasers, strobes, LEDs coloridos e fumaça.</p>
          </div>
          
          <div className="bg-white/15 backdrop-blur-lg p-6 rounded-2xl border border-white/20 text-center lg:col-span-1 md:col-span-2 md:mx-auto md:max-w-md lg:max-w-none">
            <div className="w-16 h-16 bg-gradient-to-r from-green-400 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-music-2-fill text-white text-2xl"></i>
            </div>
            <h3 className="text-white font-bold text-xl mb-3">Hits do Momento</h3>
            <p className="text-white/90 text-sm">Playlist sempre atualizada! Do funk ao eletrônico, música para todos os gostos.</p>
          </div>
        </div>
        
        <div className="bg-gradient-to-r from-pink-500/20 to-purple-500/20 backdrop-blur-lg p-8 rounded-3xl border border-white/30">
          <div className="text-center">
            <h3 className="text-3xl font-bold text-white mb-6">🔥 Benefícios da Balada com DJ Jean</h3>
            <div className="grid md:grid-cols-2 gap-6 items-center">
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-yellow-400 rounded-full flex items-center justify-center mr-3 mt-1 flex-shrink-0">
                    <i className="ri-star-fill text-black text-sm"></i>
                  </div>
                  <div className="text-left">
                    <h4 className="text-white font-bold text-base mb-1">Energia Contagiante</h4>
                    <p className="text-white/90 text-sm">Ambiente vibrante que contagia todos os convidados!</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-pink-400 rounded-full flex items-center justify-center mr-3 mt-1 flex-shrink-0">
                    <i className="ri-heart-fill text-white text-sm"></i>
                  </div>
                  <div className="text-left">
                    <h4 className="text-white font-bold text-base mb-1">Memórias Inesquecíveis</h4>
                    <p className="text-white/90 text-sm">Sua festa será lembrada para sempre!</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-blue-400 rounded-full flex items-center justify-center mr-3 mt-1 flex-shrink-0">
                    <i className="ri-team-fill text-white text-sm"></i>
                  </div>
                  <div className="text-left">
                    <h4 className="text-white font-bold text-base mb-1">União e Diversão</h4>
                    <p className="text-white/90 text-sm">Música que une pessoas e cria conexões!</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-green-400 rounded-full flex items-center justify-center mr-3 mt-1 flex-shrink-0">
                    <i className="ri-trophy-fill text-white text-sm"></i>
                  </div>
                  <div className="text-left">
                    <h4 className="text-white font-bold text-base mb-1">Festa de Sucesso</h4>
                    <p className="text-white/90 text-sm">Garantia de festa animada com pista cheia!</p>
                  </div>
                </div>
              </div>
              
              <div className="text-center">
                <div className="bg-gradient-to-br from-white/20 to-white/10 p-6 rounded-2xl border border-white/30">
                  <h4 className="text-2xl font-bold text-white mb-4">🎊 Bora Balançar! 🎊</h4>
                  <p className="text-white/90 text-sm mb-6 leading-relaxed">
                    Não perca a chance de ter a festa mais animada da sua vida! DJ Jean vai transformar seu evento numa verdadeira balada.
                  </p>
                  <div className="flex justify-center">
                    <button 
                      onClick={onWhatsAppClick}
                      className="bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-500 hover:to-orange-600 text-black px-6 py-3 rounded-full text-base font-bold transition-all transform hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap flex items-center"
                    >
                      <i className="ri-whatsapp-line mr-2"></i>
                      Vamos Fazer a Balada!
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="text-center mt-10">
          <h3 className="text-3xl font-bold text-white mb-4">🌟 A diversão não tem hora para acabar! 🌟</h3>
          <p className="text-lg text-white/90 mb-6">Com DJ Jean, sua festa vira uma verdadeira celebração da vida!</p>
          <div className="flex flex-wrap justify-center gap-3">
            <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-white font-bold text-sm">🎵 Música Top</span>
            <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-white font-bold text-sm">✨ Efeitos Especiais</span>
            <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-white font-bold text-sm">🎉 Alegria Garantida</span>
            <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-white font-bold text-sm">💃 Pista Cheia</span>
          </div>
        </div>
      </div>
      
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-10 left-10 w-24 h-24 bg-yellow-400/20 rounded-full blur-2xl animate-pulse"></div>
        <div className="absolute top-1/3 right-10 w-32 h-32 bg-pink-500/20 rounded-full blur-2xl animate-pulse delay-500"></div>
        <div className="absolute bottom-20 left-1/4 w-36 h-36 bg-blue-500/20 rounded-full blur-2xl animate-pulse delay-1000"></div>
        <div className="absolute bottom-10 right-1/3 w-28 h-28 bg-purple-500/20 rounded-full blur-2xl animate-pulse delay-1500"></div>
      </div>
    </section>
  );
}